import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { CalendarDays } from "lucide-react";
import { CHART, ChartCard, ChartEmpty, Dot, TooltipBox, axisTick, legendContent } from "./ui";

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload || payload.length === 0) return null;
  const d = payload[0]?.payload || {};
  return (
    <TooltipBox title={d.dateLabel || label}>
      <span className="flex items-center gap-1.5"><Dot color={CHART.primary} />Booking Triggered: {d.booking_initiated || 0}</span>
      <span className="flex items-center gap-1.5"><Dot color={CHART.success} />Confirmed: {d.bookings_confirmed || 0}</span>
    </TooltipBox>
  );
};

const DailyBookingsChart = ({ daily }: any) => {
  const card = (body) => (
    <ChartCard icon={<CalendarDays />} title="Daily Booking Activity" description="Bookings started and confirmed each day.">{body}</ChartCard>
  );
  if (!daily || daily.length === 0) {
    return card(<ChartEmpty icon={<CalendarDays />} text="No booking activity for selected period" />);
  }

  const chartData = daily.map((d) => ({
    ...d,
    dateLabel: d.date
      ? new Date(d.date + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "short" })
      : "",
  }));

  return card(
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={CHART.grid} vertical={false} />
        <XAxis dataKey="dateLabel" tick={axisTick} tickLine={false} axisLine={{ stroke: CHART.grid }} />
        <YAxis tick={axisTick} tickLine={false} axisLine={false} allowDecimals={false} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "var(--accent)" }} />
        <Legend content={legendContent} />
        <Bar dataKey="booking_initiated" name="Booking Triggered" fill={CHART.primary} radius={[3, 3, 0, 0]} barSize={20} />
        <Bar dataKey="bookings_confirmed" name="Confirmed" fill={CHART.success} radius={[3, 3, 0, 0]} barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default DailyBookingsChart;
